module.exports = coreApis.componentApis.video.videoCover;